// extracted by mini-css-extract-plugin
module.exports = {"loading":"components-Loading-Loading__loading--6CqM9"};